import { Avatar, Flex, Space } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { StyledButton } from "../../Common/Components";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import AddTeamToSeasonButton from "./AddTeamToSeasonButton";

const getTeamCommonColumns = ({ formatMessage }) => [
  {
    title: formatMessage({
      id: "name.local.full",
      defaultMessage: "Local Full Name",
    }),
    dataIndex: "nameFullLocal",
    render: (value, row) => (
      <Space size="small">
        <Avatar
          src={row.images?.find((image) => image?.imageType === "LOGO")?.url}
          size={25}
          loading="lazy"
          shape="square"
          alt="Team logo"
        />
        {value}
      </Space>
    ),
  },
  {
    title: formatMessage({
      id: "name.local.code",
      defaultMessage: "Local Code",
    }),
    width: 80,
    dataIndex: "codeLocal",
  },
  {
    title: formatMessage({
      id: "gender",
      defaultMessage: "Gender",
    }),
    dataIndex: "gender",
  },
  {
    title: formatMessage({
      id: "standard",
      defaultMessage: "standard",
    }),
    dataIndex: "standard",
  },
  {
    title: formatMessage({
      id: "discipline",
    }),
    dataIndex: "discipline",
  },
  {
    title: formatMessage({
      id: "ageGroup",
    }),
    dataIndex: "ageGroup",
  },
  {
    title: formatMessage({
      id: "team.id",
      defaultMessage: "Team ID",
    }),
    dataIndex: "entityId",
  },
  {
    title: formatMessage({
      id: "status",
      defaultMessage: "Status",
    }),
    dataIndex: "status",
  },
];

export const getAddTeamToSeasonColumns = ({
  formatMessage,
  sport,
  seasonId,
  organizationId,
  reloadData,
  pageRef,
  seasonEntityPermissionName,
  existingSeasonEntityIdSet,
}) => [
  ...getTeamCommonColumns({ formatMessage }),
  {
    title: null,
    align: "right",
    render: (value, row) => {
      if (existingSeasonEntityIdSet.has(row.entityId)) {
        return (
          <Flex justify="center" align="center" style={{ marginLeft: "auto", width: 24 }}>
            <i className="fas fa-check" />
          </Flex>
        );
      } else {
        return (
          <Space size="small">
            <PermissionCheck
              permissionKeys={[seasonEntityPermissionName]}
              permissionOptions={[PermissionOperations.CREATE]}
            >
              <AddTeamToSeasonButton
                sport={sport}
                seasonId={seasonId}
                organizationId={organizationId}
                entityId={row.entityId}
                reloadData={reloadData}
                pageRef={pageRef}
              />
            </PermissionCheck>
          </Space>
        );
      }
    },
  },
];

export const getTeamInSeasonColumns = ({
  formatMessage,
  customerId,
  sport,
  handleDeleteIntent,
  seasonEntityPermissionName,
}) => [
  ...getTeamCommonColumns({ formatMessage }),
  {
    title: null,
    align: "right",
    render: (value, row) => (
      <Space size="small">
        <PermissionCheck
          permissionKeys={[PermissionNames.SEASON_ROSTER]}
          permissionOptions={[PermissionOperations.READ]}
        >
          <StyledButton size="small" type="text">
            <Link
              to={`/${customerId}/admin/${sport}/${row.organizationId}/seasons/${row.seasonId}/entities/${row.entityId}/roster/`}
            >
              {formatMessage({
                id: "roster",
                defaultMessage: "Roster",
              })}
            </Link>
          </StyledButton>
        </PermissionCheck>
        <PermissionCheck permissionKeys={[PermissionNames.ROLES]} permissionOptions={[PermissionOperations.READ]}>
          <StyledButton size="small" type="text">
            <Link
              to={`/${customerId}/admin/${sport}/${row.organizationId}/seasons/${row.seasonId}/entities/${row.entityId}/staff`}
            >
              <FormattedMessage id="staff" />
            </Link>
          </StyledButton>
        </PermissionCheck>
        <PermissionCheck
          permissionKeys={[seasonEntityPermissionName]}
          permissionOptions={[PermissionOperations.UPDATE]}
        >
          <StyledButton size="small" type="text">
            <Link
              to={
                `/${customerId}/admin/` +
                sport +
                "/" +
                row.organizationId +
                "/seasons/" +
                row.seasonId +
                "/entities/" +
                row.entityId
              }
            >
              {formatMessage({
                id: "details",
                defaultMessage: "Details",
              })}
            </Link>
          </StyledButton>
        </PermissionCheck>
        <PermissionCheck
          permissionKeys={[seasonEntityPermissionName]}
          permissionOptions={[PermissionOperations.DELETE]}
        >
          <StyledButton
            icon={<i className={"fas fa-trash"}></i>}
            size="small"
            type="text"
            onClick={() => handleDeleteIntent(row.entityId)}
          ></StyledButton>
        </PermissionCheck>
      </Space>
    ),
  },
];
